import layoutHeaderAside from '@/layout/header-aside'

const meta = { requiresAuthA: true }

export default {
  path: '/',
  name: 'message',
  meta,
  component: layoutHeaderAside,
  children: (pre => [
    { path: 'message', name: `${pre}index`, component: () => import('@/pages/message'), meta: { meta, title: '消息管理' } },
    { path: 'message/messageDetail', name: `${pre}messageDetail`, component: () => import('@/pages/message/messageDetail'), meta: { meta, title: '消息详情' } },
    { path: 'message/addMessage', name: `${pre}addMessage`, component: () => import('@/pages/message/addMessage'), meta: { meta, title: '新增消息' } }
  ])('message-')
}
